﻿import { apiUsers } from "../../api/axiosClient";
import { modal } from "../../utils/antdStatic";
import { useDispatch, useSelector } from "react-redux";
import { storeDataTracking } from "../../redux/state/tracking/traking";
import { STORAGE_GEO_CONSENT } from "../../utils/storageKeys";

const useActivityTracker = () => {

  /* --------------------------  --------------------------  */

  const { codigoAfiliado, token } = useSelector((state) => state.user);

  /* --------------------------  --------------------------  */

  const dispatch = useDispatch();

  /* --------------------------  --------------------------  */

  // Solicita consentimiento explícito al usuario (sólo la primera vez)
  const requestGeoConsent = () =>
    new Promise((resolve) => {
      modal.confirm({
        title: "Permiso de ubicación",
        content:
          "Esta aplicación registra tu ubicación geográfica (latitud y longitud) únicamente con fines de auditoría de seguridad. " +
          "La información se almacena de forma segura y no es compartida con terceros. " +
          "¿Autorizas el uso de tu ubicación?",
        okText: "Permitir",
        cancelText: "Denegar",
        onOk() {
          localStorage.setItem(STORAGE_GEO_CONSENT, "granted");
          resolve(true);
        },
        onCancel() {
          localStorage.setItem(STORAGE_GEO_CONSENT, "denied");
          resolve(false);
        },
      });
    });

  /* --------------------------  --------------------------  */

  // Obtiene la ubicación sólo si hay consentimiento
  const getLocation = async (callback) => {
    let consent = localStorage.getItem(STORAGE_GEO_CONSENT);

    // Primera vez: mostrar modal de consentimiento
    if (!consent) {
      const granted = await requestGeoConsent();
      consent = granted ? "granted" : "denied";
    }

    // Sin consentimiento o sin soporte → enviar coordenadas nulas
    if (consent !== "granted" || !navigator.geolocation) {
      callback({ latitude: null, longitude: null });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        callback({ latitude, longitude });
      },
      () => {
        // Error de permisos del navegador u otro → enviar nulos sin romper el flujo
        callback({ latitude: null, longitude: null });
      }
    );
  };

  /* --------------------------  --------------------------  */

  const logActivity = (user, profile, currentPage) => {
    if (!token || !codigoAfiliado) return;
    const timestamp = new Date().toISOString();

    getLocation(async (location) => {
      const activity = {
        user,
        profile,
        currentPage,
        latitude: location.latitude ?? 0,
        longitude: location.longitude ?? 0,
        timestamp,
      };

      // Registrar o enviar el log al servidor
      await apiUsers.post("/registrarAuditoria", null, {
        params: {
          IdentUser: codigoAfiliado,
          Usuario: activity.user,
          IdPerfil: activity.profile,
          Accion: activity.currentPage,
          Latitud: activity.latitude,
          Longitud: activity.longitude,
          token: token,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            dispatch(storeDataTracking(response.data));
          }
        })
        .catch((error) => {
          console.error("Error al registrar la actividad:", error);
        });
    });
  };

  /* --------------------------  --------------------------  */

  return { logActivity };
};

export default useActivityTracker;
